/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;
	const dummyImg = '<img src="/images/dummy/photo.webp" loading="lazy" alt="">';
	let interviewMessage = document.createElement('p');
	interviewMessage.className = 'js-messageTxt __messageTxt';
	interviewMessage.textContent = '該当の社員インタビューはございません。';

	// JSON取得用 ===============================================================
	const interviewJson = (_directory, _param) => `/ajax/recruit/${_directory}/interview/list.json${_param}`;
	const contentsJson = (_param) => `/ajax/recruit/graduate/keyword/list.json${_param}`;
	const crossTalkJson = (_directory) => `/ajax/recruit/${_directory}/crosstalk/list.json`;

	// ==========================================================================
	// <TOP> 空タグ削除&リンクにパラメータ付与
	const emptyTag = () => {
		let peopleItem = document.querySelectorAll('.js-people');
		if (peopleItem.length) {
			peopleItem.forEach((ele, idx) => {
				// 空タグ削除
				let tag = ele.querySelectorAll('.cf_n_tags');
				tag.forEach((ele2, idx2) => {
					if (ele2.textContent === '') {
						ele2.remove();
					}
				});

				// リンクにパラメータ付与
				let division = ele.querySelector('.rt_cf_n_tags_division').textContent;
				let thisUrl = ele.getAttribute('href');
				ele.setAttribute('href', thisUrl);
			});
		}
	};

	// <TOP> headerスライダー
	const headerSlider = () => {
		if (document.querySelectorAll('.top-slider01').length) {
			const topslider01 = new Swiper('.top-slider01', {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				loopAdditionalSlides: 0,
				speed: 1000,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.top-slider01-control .swiper-pagination',
					clickable: true,
				}
			});
			document.querySelector('.top-slider01-control-button').addEventListener('click', (e) => {
				if (!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					topslider01.autoplay.start();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					topslider01.autoplay.stop();
				}
			});
		}
	}

	// <TOP> Peopleスライダー
	const peopleSwiper = () => {
		if (document.querySelectorAll('.js-peopleSlider').length) {
			let slider1;
			window.addEventListener('load', () => {
				slider1 = new Swiper('.js-peopleSlider', {
					slidesPerView: 1.2,
					spaceBetween: 30,
					loop: true,
					speed: 1000,
					// loopAdditionalSlides: 1,
					autoplay: {
						delay: 5000,
						// disableOnInteraction: false,
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						// スライドの表示枚数：1025px以上の場合
						1025: {
							slidesPerView: 3,
							spaceBetween: 70,
						}
					},
					on: {
						init: (swiper) => {
							const slides = swiper.slides;
							if (slides.length > swiper.loopedSlides) {
								const wrapper = swiper.wrapperEl
								slides.forEach(function (slide) {
									wrapper.append(slide.cloneNode(true));
								})
							}
						},
						afterInit: (swiper) => {
							setTimeout(() => {
								const paginations = swiper.pagination.bullets;
								paginations.forEach((pagination, index) => {
									if(index > (paginations.length / 2) - 1){
										pagination.remove()
									}
								})
							},500);
						}
					},
				});

				// アクセシビリティ対応文言
				let stopTxt = '停止';
				let startTxt = '再生';

				// 停止・再生
				let stopBtns = document.querySelectorAll('.recruit-top-people-slider-stopbtn');
				let pageNation = document.querySelector('.swiper-pagination');
				stopBtns.forEach((stopBtn) => {
					stopBtn.addEventListener('click', (e) => {
						let classList = e.currentTarget.classList;

						if (classList.contains('stop')) {
							classList.add('start');
							classList.remove('stop');
							pageNation.classList.add('stop');
							slider1.autoplay.stop();
							document.querySelector('.js-peopleSlider').classList.add('is-stop');
							stopBtn.ariaLabel = startTxt;
						} else {
							classList.add('stop');
							classList.remove('start');
							pageNation.classList.remove('stop');
							slider1.autoplay.start();
							document.querySelector('.js-peopleSlider').classList.remove('is-stop');
							stopBtn.ariaLabel = stopTxt;
						}
					});
				});
			});
		}
	};

	// <社員インタビュー>描画
	const createInterviewList = async () => {
		let $list = document.querySelectorAll('.js-interviewList');
		const params = new URLSearchParams();

		if ($list.length) {
			let directory = $path.split('/')[$path.split('/').length - 2];
			if (directory !== 'interview') {
				if (directory === 'detail') {
					if (document.querySelector('.rt_cf_n_tags_department')) {
						params.set('p_department', document.querySelector('.rt_cf_n_tags_department').textContent);
					} else {
						document.querySelector('.js-interviewList-wrap').remove();
					}
				} else {
					params.set('p_department', directory);
				}

				// タブ
				document.querySelectorAll('.js-department').forEach((ele, idx) => {
					if (ele.getAttribute('href') === $path.replace('index.html', '')) {
						ele.classList.add(a);
					} else {
						ele.classList.remove(a);
					}
				});
			}

			const getJson = async (_param) => {
				let allHtml = '';
				let detailKey = $path.split('/')[$path.split('/').length - 1].replace('.html', '');
				$list[0].querySelectorAll('li').forEach(item => {
					item.remove();
				})
				let directory = $path.split('/')[2];

				await fetch(interviewJson(directory, _param))
					.then(response => response.json())
					.then(data => {
						let dataList = data.rt_bn_news_interview;
						let count = 0;
						if (dataList.length) {
							const errorMsg = document.querySelector('.js-messageTxt');
							if (errorMsg) {
								errorMsg.remove();
							}
							if ($path.indexOf('/detail/') !== -1) {
								if (dataList.length <= 1) {
									document.querySelector('.js-interviewList-wrap').remove();
								}
							}
							dataList.forEach((ele, idx) => {
								let thisKey = ele._key;
								var thisUrl = eval('ele.rt_cf_n_href_' + directory + '.href');
								let thisTitle = ele.rt_cf_n_title.content;
								let thisYear = ele.rt_cf_n_join_year;
								let thisImg = ele.rt_cf_n_thum_img;// ない場合もある
								let thisTags = ele.cf_n_tags;
								let thisDivision;
								let tagList = [];

								if (thisKey !== detailKey) {
									// 詳細ページ
									if ($path.indexOf('/detail/') !== -1) {
										count += 1;
										if (count >= 7) {
											return;
										}
									}

									thisTags.forEach((ele2, idx2) => {
										if (ele2.rt_cf_n_tags_division !== null) {
											thisDivision = ele2.rt_cf_n_tags_division.content;
										} else {
											if (ele2.rt_cf_n_tags_keyword !== null) {
												tagList.push(ele2.rt_cf_n_tags_keyword.content);
											}
										}
									});

									allHtml += '<li class="pure-u-1-3 pure-u-tab-1-2 pure-u-sp-1">';
									allHtml += '<a href="' + thisUrl + '" class="recruit-interview-list-a">';
									allHtml += '<div class="__img"><figure>';
									if (thisImg !== null) {
										allHtml += '<img src="' + thisImg.src + '" loading="lazy" alt="' + thisImg.alt + '">';
									} else {
										allHtml += dummyImg;
									}
									allHtml += '</figure>';
									allHtml += '<span class="__label">' + thisDivision + '</span></div>';
									allHtml += '<p class="__txtWrap"><span class="__name">' + thisTitle + '</span>';
									if (thisYear !== null) {
										allHtml += '<span class="__year">' + thisYear.content + '</span>';
									}
									allHtml += '</p>';
									if (tagList.length) {
										allHtml += '<ul class="__tagWrap">';
										tagList.forEach((ele2, idx2) => {
											allHtml += '<li class="__tag"><span class="mod-tag">' + ele2 + '</span></li>';
										});
										allHtml += '</ul>';
									}
									allHtml += '</a></li>';
								}
							});
						} else {
							$list[0].before(interviewMessage);
						}
					})
					.then(() => {
						$list[0].innerHTML = allHtml;
					})
					.then(() => {
						listMore();
					})
					.catch(() => ({}));
			};

			await getJson('?' + params.toString());

			// ラジオボタン選択時
			const sortBlock = document.querySelectorAll('.js-sortBlock');
			if (sortBlock.length) {
				(sortBlock[0].querySelectorAll('.mod-radio input')).forEach((el, idx) => {
					el.addEventListener('change', () => {
						let thisName = el.getAttribute('name');
						let thisValue = el.nextElementSibling.getAttribute('data-code');
						// console.log(thisName,thisValue);

						if (thisValue !== null) {
							params.set(thisName, thisValue);
						} else {
							params.set(thisName, '');
						}
						getJson('?' + params.toString());

						// if (thisValue !== null) {
						// 	url.searchParams.set(thisName, thisValue);
						// } else {
						// 	url.searchParams.set(thisName, '');
						// }
						// getJson(url.search);
					});
					// ele.addEventListener('click', () => {
					// 	let thisName = ele.getAttribute('for');
					// 	document.querySelectorAll('label[for="'+ thisName +'"]').forEach((ele,idx) => {
					// 		ele.querySelector('input').checked = false;
					// 	});
					// 	let thisValue = ele.querySelector('.mod-radio-text').getAttribute('data-code');
					// 	ele.querySelector('input').checked = true;
					// 	if(thisValue !== null) {
					// 		url.searchParams.set(thisName, thisValue);
					// 	} else {
					// 		url.searchParams.set(thisName,'');
					// 	}
					// 	getJson(url.search);
					// });
				});
				// キーワード選択時
				(sortBlock[0].querySelectorAll('.js-keyword')).forEach((el, idx) => {
					el.addEventListener('click', () => {
						let thisKeyword = el.querySelector('span').getAttribute('data-code');

						const keywords = params.getAll('p_keyword') || [];

						let isDelete = false;

						if (keywords.includes(thisKeyword)) {
							params.delete('p_keyword');
							keywords.filter(keyword => keyword !== thisKeyword).forEach(keyword => params.append('p_keyword', keyword));
							isDelete = true;
						} else {
							params.append('p_keyword', thisKeyword);
							isDelete = false;
						}

						getJson('?' + params.toString()).then(() => {
							isDelete ? el.classList.remove('current') : el.classList.add('current');
						});
					});
				});
			}
		}
	};

	// <コンテンツ検索>
	const contentsSearch = async () => {
		let $list = document.querySelectorAll('.js-contentsList');
		const params = new URLSearchParams();

		if ($list.length) {
			const getJson = async (_param) => {
				let allHtml = '';
				$list[0].querySelectorAll('li').forEach(item => {
					item.remove();
				})

				await fetch(contentsJson(_param))
					.then(response => response.json())
					.then(data => {
						let dataList = data.rt_bn_news_search;
						if (dataList.length) {
							dataList.forEach((ele, idx) => {
								let thisUrl = ele.rt_cf_n_href;
								let thisTitle = ele.rt_cf_n_title.content;
								let thisImg = ele.rt_cf_n_thum_img;// ない場合もある
								let thisTags = ele.cf_n_tags;
								allHtml += '<li class="pure-u-1-3 pure-u-tab-1-2 pure-u-sp-1">';
								allHtml += '<a href="' + thisUrl.href + '" target="' + thisUrl.target + '" class="recruit-interview-list-a">';
								allHtml += '<div class="__img"><figure>';
								if (thisImg !== null) {
									allHtml += '<img src="' + thisImg.src + '" loading="lazy" alt="' + thisImg.alt + '">';
								} else {
									allHtml += dummyImg;
								}
								allHtml += '</figure></div>';
								allHtml += '<p class="__tit">' + thisTitle + '</p><ul class="__tagWrap">';
								thisTags.forEach((ele2, idx2) => {
									allHtml += '<li class="__tag"><span class="mod-tag">' + ele2.rt_cf_n_tags_search.content + '</span></li>';
								});
								allHtml += '</ul></a></li>';
							});
						}
					})
					.then(() => {
						$list[0].innerHTML = allHtml;
					})
					.then(() => {
						listMore();
					})
					.catch(() => ({}));
			};

			await getJson('?' + params.toString());

			// ラジオボタン選択時
			const sortBlock = document.querySelectorAll('.js-sortBlock');
			if (sortBlock.length) {
				// キーワード選択時
				(sortBlock[0].querySelectorAll('.js-keyword')).forEach((el, idx) => {
					el.addEventListener('click', async () => {
						let thisKeyword = el.querySelector('span').getAttribute('data-code');

						const searches = params.getAll('p_search') || [];
						if (searches.includes(thisKeyword)) {
							params.delete('p_search');
							searches.filter(keyword => keyword !== thisKeyword).forEach(keyword => params.append('p_search', keyword));
							el.classList.remove('current');
						} else {
							params.append('p_search', thisKeyword);
							el.classList.add('current');
						}

						await getJson('?' + params.toString());
					});
				});
				// リセットボタン
				sortBlock[0].querySelector('.js-reset').addEventListener('click', async () => {
					if (sortBlock[0].querySelectorAll('.js-keyword.current').length) {
						params.delete('p_search');
						(sortBlock[0].querySelectorAll('.js-keyword')).forEach((el, idx) => {
							el.classList.remove('current');
						});

						await getJson('?' + params.toString());
					}
				});
			}

		}
	}

	// <クロストーク>描画
	const createCrossTalk = async () => {
		let $list = document.querySelectorAll('.js-crossTarkList');
		if ($list.length) {
			let directory = $path.split('/')[2];
			const getJson = async (directory) => {
				let allHtml = '';
				let count = 0;

				await fetch(crossTalkJson(directory))
					.then(response => response.json())
					.then(data => {
						let dataList = data.rt_bn_news_crosstalk;
						if (dataList.length) {
							dataList.forEach((ele, idx) => {
								let thisKey = ele._key;
								let thisImg = ele.rt_cf_n_thum_img;
								let thisTitle = ele.rt_cf_n_title.content[0];
								let thisOverview = ele.rt_cf_n_overview;
								let thisUrl = ele.rt_cf_n_href_crosstalk.href;

								if ($path.indexOf('/detail/') !== -1) {
									if (dataList.length > 1) {
										let detailKey = $path.split('/')[$path.split('/').length - 1].replace('.html', '');
										if (thisKey !== detailKey) {
											count += 1;
											if (count <= 2) {
												allHtml += '<li class="pure-u-1-2 pure-u-sp-1">';
												allHtml += '<a href="' + thisUrl + '" class="recruit-crosstalk-other-a"><figure class="__img">';
												if (thisImg !== null) {
													allHtml += '<img src="' + thisImg.src + '" loading="lazy" alt="' + thisImg.alt + '">';
												} else {
													allHtml += dummyImg;
												}
												allHtml += '<span class="_icon"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right_02"></use></svg></span></figure>';
												allHtml += '<p class="__tit">' + thisTitle + '</p>';
												if (thisOverview !== null) {
													allHtml += '<p class="__txt">' + thisOverview.content.replace(/\n|\r\n/g, '<br>') + '</p>';
												}
												allHtml += '</a></li>';
											}
										}
									} else {
										document.querySelector('.recruit-crosstalk-other').remove();
									}

								} else {
									allHtml += '<li><a href="' + thisUrl + '" class="recruit-crosstalk-list-item">';
									allHtml += '<figure class="__img">';
									if (thisImg !== null) {
										allHtml += '<img src="' + thisImg.src + '" loading="lazy" alt="' + thisImg.alt + '">';
									} else {
										allHtml += dummyImg;
									}
									allHtml += '</figure><div class="recruit-crosstalk-list-item-box"><h3 class="__tit">';
									allHtml += '<span class="">' + thisTitle + '<span class="_icon"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right_02"></use></svg></span></h3></span>';
									if (thisOverview !== null) {
										allHtml += '<p class="__txt">' + thisOverview.content.replace(/\n|\r\n/g, '<br>') + '</p>';
									}
									allHtml += '</div></a></li>';
								}
							});
						}
					})
					.then(() => {
						$list[0].innerHTML = allHtml;
					})
					.then(() => {
						listMore();
					})
					.catch(() => ({}));
			}
			await getJson(directory);
		}
	};

	// <社員インタビュー／クロストーク／コンテンツ検索>もっと見る
	const listMore = () => {
		let endNum = 12;
		if ($path.indexOf('/crosstalk/') !== -1) {
			endNum = 4;
		}
		if (document.querySelector('.js-listWrap')) {
			let $list = document.querySelectorAll('.js-listWrap');
			if ($list.length) {
				$list.forEach((ele, idx) => {
					var listItems = ele.querySelectorAll('.js-list > li');
					var moreBtn = ele.querySelector('.js-listMore');
					moreBtn.classList.remove('di_none');

					if (listItems.length) {
						var startCnt = 0, endCnt = endNum;

						function addResult() {
							for (var i = startCnt; i < endCnt; i++) {
								if (listItems[i]) {
									listItems[i].classList.add(v);
									moreBtn.classList.add(v);
								} else {
									// moreBtn.remove();
									moreBtn.classList.add('di_none');
									break;
								}
							}

							if (listItems.length === endCnt) {
								// moreBtn.remove();
								moreBtn.classList.add('di_none');
							}
						}

						// 最初の12件（クロストークは4件）表示
						addResult();

						if (listItems.length <= endNum) {
							// moreBtn.remove();
							moreBtn.classList.add('di_none');
						}

						const moreBtnEvent = function () {
							startCnt += endNum;
							endCnt += endNum;
							addResult();
						};

						// moreボタン押下で次の12個（クロストークは4件）を表示
						moreBtn.removeEventListener('click', moreBtnEvent);
						moreBtn.addEventListener('click', moreBtnEvent);
					} else {
						moreBtn.classList.add('di_none');
					}
				});
			}
		}
	}

	// <共通>ヘッダー
	const recruitHeader = () => {
		const headerMenu = document.querySelectorAll('.js-recruit-headerMenu');
		headerMenu.forEach(ele => {
			if ($path.indexOf(ele.getAttribute('data-name')) !== -1) {
				ele.classList.remove('di_none');
			}
		});
	}
	// <共通>フッター
	const recruitFooter = () => {
		const headerMenu = document.querySelectorAll('.js-recruit-footerMenu');
		headerMenu.forEach(ele => {
			if ($path.indexOf(ele.getAttribute('data-name')) !== -1) {
				ele.classList.remove('di_none');
			}
		});
	}

	const recuruitIsScroll = () => {
		// スクロールされたときヘッダーの色変更
		let currentPosition = 0;

		const isAtTheTop = () => {
			const scroll = window.scrollY;
			const recruitBtns = document.querySelector('.recruit-top-main-btns');
			if (recruitBtns) {
				if (scroll > 0) {
					recruitBtns.classList.add('is-scroll')
				} else {
					recruitBtns.classList.remove('is-scroll')
				}
			}
		}
		const isDown = () => {
			const scroll = window.scrollY;
			const recruitBtns = document.querySelector('.recruit-top-main-btns');
			if (recruitBtns) {
				if (scroll > currentPosition) {
					recruitBtns.classList.add('is-down')
				} else {
					recruitBtns.classList.remove('is-down')
				}
			}

			currentPosition = scroll
		}

		isAtTheTop()

		window.addEventListener("scroll", function () {
			isAtTheTop()
			isDown()
		});
	};

	// ================================
	const init = async () => {
		emptyTag();
		headerSlider();
		peopleSwiper();
		await createInterviewList();
		await contentsSearch();
		await createCrossTalk();
		// window.onload = function(){
		recruitHeader();
		recruitFooter();
		// }
		recuruitIsScroll();

	};

	init();

})(window.FUNCTIONS);
